import { render, staticRenderFns } from "./MedicationPopup.vue?vue&type=template&id=f2d8dac6&scoped=true&"
import script from "./MedicationPopup.vue?vue&type=script&lang=js&"
export * from "./MedicationPopup.vue?vue&type=script&lang=js&"
import style0 from "./MedicationPopup.vue?vue&type=style&index=0&id=f2d8dac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d8dac6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardTitle,VDialog})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1532393991/src/playtient-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2d8dac6')) {
      api.createRecord('f2d8dac6', component.options)
    } else {
      api.reload('f2d8dac6', component.options)
    }
    module.hot.accept("./MedicationPopup.vue?vue&type=template&id=f2d8dac6&scoped=true&", function () {
      api.rerender('f2d8dac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MedicationPopup.vue"
export default component.exports